import apiService from "services/apiService";

export const skillService = {
  getAllSkills() {
    return apiService.get("/api/admin/skill");
  },

  addSkills(payload: { skill: string }[]) {
    return apiService.post("/api/admin/skill/add", payload);
  },

  updateSkill(id: number, skill: string) {
    return apiService.put("/api/admin/skill/update", [
      {
        id,
        skill,
      },
    ]);
  },

  deleteSkill(id: number) {
    return apiService.delete(`/api/admin/skill/delete/${id}`);
  },
};